import { ObjektId } from '@models/objekt-id';
import { IdentitaetPruefenResult } from 'app/core/services/api-client';

export interface IMergeState {
  result: IdentitaetPruefenResult | null;
  additionalId?: number | null;
  isBusy: boolean;
  canMerge: boolean;
  id: ObjektId | null;
}

export const initialState: IMergeState = {
  result: null,
  additionalId: null,
  isBusy: false,
  canMerge: false,
  id: null,
};
